import AggregateTimelineStrip from './AggregateTimelineStrip.ts.vue';
import Badge from './Badge.vue';
import Bulb from './Bulb.ts.vue';
import Chart from './Chart.vue';
import ColourLegend from './ColourLegend.vue';
import Gauge from './Gauge.vue';
import KpiPieChart from './KpiPieChart.vue';
import PercentBar from './PercentBar.ts.vue';
import PieChart from './PieChart.vue';
import RingGauge from './RingGauge.vue';
import SimpleChart from './SimpleChart.vue';
import Tabular from './Tabular/Tabular.vue';
import TimelineStrip from './TimelineStrip.ts.vue';

export default [
  AggregateTimelineStrip,
  Badge,
  Bulb,
  Chart,
  ColourLegend,
  Gauge,
  KpiPieChart,
  PercentBar,
  PieChart,
  RingGauge,
  SimpleChart,
  Tabular,
  TimelineStrip,
];
